import Firebase from '../../../firebase';
import { NEWS_COLLECTION } from '../../../firebase/collections';
import firebase from 'firebase/app';
import 'firebase/firestore';

const collection = Firebase.db.collection(NEWS_COLLECTION);
const storage = Firebase.storage;

const uploadImageToStorage = async (file) => {
  if (!file) return null;

  try {
    const timestamp = Date.now();
    const fileName = `${timestamp}_${file.name}`;
    const storageRef = storage.ref(`news-images/${fileName}`);

    const snapshot = await storageRef.put(file);
    const downloadURL = await snapshot.ref.getDownloadURL();

    return downloadURL;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw new Error('Failed to upload image');
  }
};

const deleteImageFromStorage = async (imageUrl) => {
  if (!imageUrl || !imageUrl.includes('firebase')) return;

  try {
    const imageRef = storage.refFromURL(imageUrl);
    await imageRef.delete();
  } catch (error) {
    console.error('Error deleting image:', error);
  }
};

export const requestAddNews = async ({ imageFile, ...restProps }) => {
  try {
    let imageUrl = restProps.imageUrl || '';

    if (imageFile) {
      imageUrl = await uploadImageToStorage(imageFile);
    }

    const dataToSave = {
      ...restProps,
      imageUrl,
      createdAt: new Date().toISOString()
    };

    delete dataToSave.imageFile;

    const docRef = await collection.add(dataToSave);

    return { id: docRef.id, ...dataToSave };

  } catch (error) {
    console.error('Error adding news:', error);
    throw error;
  }
};

export const requestEditNews = async ({ id, imageFile, ...restProps }) => {
  try {
    let imageUrl = restProps.imageUrl || '';

    if (imageFile) {
      const doc = await collection.doc(id).get();
      const oldImageUrl = doc.data()?.imageUrl;

      imageUrl = await uploadImageToStorage(imageFile);

      if (oldImageUrl && oldImageUrl !== imageUrl) {
        await deleteImageFromStorage(oldImageUrl);
      }
    }

    const dataToUpdate = {
      ...restProps,
      imageUrl,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    delete dataToUpdate.imageFile;

    await collection.doc(id).update(dataToUpdate);

    return id;
  } catch (error) {
    console.error('Error editing news:', error);
    throw error;
  }
};

export const requestDeleteNews = async (id) => {
  try {
    const doc = await collection.doc(id).get();
    const imageUrl = doc.data()?.imageUrl;

    await collection.doc(id).delete();

    if (imageUrl) {
      await deleteImageFromStorage(imageUrl);
    }

    return id;
  } catch (error) {
    console.error('Error deleting news:', error);
    throw error;
  }
};

export const requestUpdateNewsSequence = async (list) =>
  Promise.all(list.map((item, index) => collection.doc(item.id).update({ index: index + 1 })));

export const requestFetchNews = async () => {
  return await collection
    .get()
    .then((snapshot) => snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
};